// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"ServiceAddForm_formWrapper__2D4nj","headerWrapper":"ServiceAddForm_headerWrapper__hTtBd"};